import { createBrowserRouter } from 'react-router-dom';
import { AuthGuard } from './auth/AuthGuard.js';
import { Layout } from './components/Layout.js';
import { Dashboard } from './pages/Dashboard.js';
import { Conexiones } from './pages/Conexiones.js';
import { Campanas } from './pages/Campanas.js';
import { Templates } from './pages/Templates.js';
import { Variables } from './pages/Variables.js';
import { Reportes } from './pages/Reportes.js';
import { Estado } from './pages/Estado.js';
import { Configuracion } from './pages/Configuracion.js';
import { Flujos } from './pages/Flujos.js';
import { NotFound } from './pages/NotFound.js';
import { LoginPage } from './pages/Login.js';
import { CallbackPage } from './pages/Callback.js';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/callback', element: <CallbackPage /> },
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'conexiones', element: <Conexiones /> },
      { path: 'campanas', element: <Campanas /> },
      { path: 'flujos', element: <Flujos /> },
      { path: 'templates', element: <Templates /> },
      { path: 'variables', element: <Variables /> },
      { path: 'reportes', element: <Reportes /> },
      { path: 'estado', element: <Estado /> },
      { path: 'configuracion', element: <Configuracion /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);
